export const ExpertField = [
  { fieldsName: "General Text" },
  { fieldsName: "Art / Culture" },
  { fieldsName: "Business / Economy" },
  { fieldsName: "Electronics / Engineering" },
  { fieldsName: "E-mails / Letters" },
  { fieldsName: "Environment / Energy" },
  { fieldsName: "Fashion / Cosmetics" },
  { fieldsName: "Games / Video Games / Casino" },
  { fieldsName: "General Business / Commerce" },
  { fieldsName: "Finance / Insurance" },
  { fieldsName: "Internet /e-commerce" },
  { fieldsName: "Legal documents / Contracts" },
  { fieldsName: "fieldsNameterary Translations" },
  { fieldsName: "Marketing / Advertising material / PR" },
  { fieldsName: "Mechanical / Manufacturing" },
  { fieldsName: "Medical / Pharmaceutical" },
  { fieldsName: "Private / Leisure" },
  { fieldsName: "RefieldsNamegion" },
  { fieldsName: "Science / Research" },
  { fieldsName: "Software / Internet" },
  { fieldsName: "Telecommunications" },
  { fieldsName: "Travel / Tourism" },
  { fieldsName: "CV / Resume" },
];
